import { useEffect, useState } from 'react';

import { useDrawerControls } from 'components/common/zolaUI/Drawer';

export function useBudgetUnsavedChanges(
  callback: () => void
): { hasUnsavedChanges: boolean; setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void } {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const { setOnUnsavedChanges, setShowSavePrompt } = useDrawerControls();
  useEffect(() => {
    if (hasUnsavedChanges) {
      setOnUnsavedChanges(() => {
        callback();
        setShowSavePrompt(true);
      });
    } else {
      setShowSavePrompt(false);
      setOnUnsavedChanges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUnsavedChanges]);

  return { hasUnsavedChanges, setHasUnsavedChanges: newValue => setHasUnsavedChanges(newValue) };
}

export default useBudgetUnsavedChanges;
